// extracted by mini-css-extract-plugin
module.exports = {"SearchResultList":"SearchResultList_SearchResultList__3qJ_W","SearchResultList_grid":"SearchResultList_SearchResultList_grid__MRYmz"};